<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText readonly="{{formReadOnly}}">
            <label for="name">Name</label>
            @for (validation of validationMessages.name; track validation) {
              <span>
                @if (form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Template Variables Reference Section -->
        <div class="col-lg-12 mt-2 mb-3">
          <hr>
            <h5 style="margin-bottom: 12px;">
              <i class="pi pi-code" style="margin-right: 6px;"></i>
              Template Variables Reference
              <small class="text-muted" style="font-size: 0.75rem; margin-left: 8px;">(click any variable to copy)</small>
            </h5>

            @if (templateVarsLoading) {
              <div style="padding: 8px 0; color: #888;">
                <i class="pi pi-spin pi-spinner"></i> Loading variables...
              </div>
            }

            <!-- Search box -->
            @if (!templateVarsLoading && templateVarGroups.length > 0) {
              <div style="margin-bottom: 10px; position: relative;">
                <span class="p-input-icon-left w-100">
                  <i class="pi pi-search" style="left: 10px; top: 50%; transform: translateY(-50%); position: absolute; color: #888;"></i>
                  <input
                    pInputText
                    type="text"
                    [value]="templateVarSearch"
                    (input)="templateVarSearch = $any($event.target).value; onTemplateVarSearch()"
                    placeholder="Search variables..."
                    style="width: 100%; padding-left: 32px; font-size: 0.9rem;"
                    />
                  </span>
                  @if (templateVarSearch && filteredTemplateVarGroups.length === 0) {
                    <small style="color: #dc3545;">
                      No variables match "{{ templateVarSearch }}"
                    </small>
                  }
                  @if (templateVarSearch && filteredTemplateVarGroups.length > 0) {
                    <small style="color: #6c757d;">
                      {{ filteredTemplateVarGroups.length }} group(s) found
                    </small>
                  }
                </div>
              }

              @if (!templateVarsLoading && templateVarGroups.length === 0) {
                <div style="color: #888; font-style: italic;">
                  No template variables found.
                </div>
              }

              @for (grp of filteredTemplateVarGroups; track grp) {
                <div style="margin-bottom: 6px; border: 1px solid #dee2e6; border-radius: 4px; overflow: hidden;">
                  <!-- Group Header -->
                  <div
                    (click)="toggleGroup(grp.group)"
                    style="display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; cursor: pointer; background-color: #f8f9fa; font-weight: 600; font-size: 0.9rem;"
                    [style.border-bottom]="expandedGroups[grp.group] ? '1px solid #dee2e6' : 'none'"
                    >
                    <span>{{ grp.group }}</span>
                    <span style="display: flex; align-items: center; gap: 8px;">
                      @if (templateVarSearch) {
                        <small style="font-weight: normal; color: #6c757d; font-size: 0.75rem;">{{ grp.vars.length }} var(s)</small>
                      }
                      <i [class]="expandedGroups[grp.group] ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="font-size: 0.75rem;"></i>
                    </span>
                  </div>
                  <!-- Group Variables -->
                  @if (expandedGroups[grp.group]) {
                    <div style="padding: 10px 12px; display: flex; flex-wrap: wrap; gap: 6px; background: #fff;">
                      @for (v of grp.vars; track v) {
                        <span
                          (click)="copyToClipboard(v)"
                          title="Click to copy"
                          [innerHTML]="highlightMatch(v)"
                          style="display: inline-block; cursor: pointer; background-color: #e9ecef; border: 1px solid #ced4da; border-radius: 3px; padding: 2px 8px; font-family: monospace; font-size: 0.82rem; color: #495057;"
                        ></span>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="col-lg-12">
              <h6 for="isHelp">Mini Doc</h6>
					<editor formControlName="miniDoc" id="helpComponentMiniDoc" [disabled]="formReadOnly" [toolbar]="" [init]="{
							height: 800,
							base_url: '/tinymce',
							suffix: '.min',
							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
      toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}" >
              </editor>
              @for (validation of validationMessages.isHelp; track validation) {
                <span>
                  @if (form1.get('miniDoc').hasError(validation.type) && (form1.get('miniDoc').dirty || form1.get('miniDoc').touched)) {
                    <small class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </div>

          </div>
        </div>
        <hr>
          @if (!formReadOnly) {
            <div class="row m-0">
              <div class="col-lg-12">
                <div class="btn-group">
                  <div class="button-group">
                    @if (helpId) {
                      <button pButton class="btn-delete p-button-outlined p-button-danger"
                      (click)="onFormDelete()">Delete</button>
                    }
                  </div>
                  <div class="button-group">
                    <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
                    @if (!helpId) {
                      <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
                    }
                    @if (helpId) {
                      <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>